import React, { useEffect, useState } from "react";
import { num } from "../../utils/num";
import img from "../../Assets/Balance/coin.png";
import Access from "./components/Access";
import SendCoins from "./components/SendCoins";
import AddTarget from "./components/AddTarget";
import Analytics from "./Analytics/Analytics";
import { getCategoryAnalytics } from "./Analytics/analyticsApi";
import RunStatusBar from "./Analytics/RunStatusBar";
import { useDispatch, useSelector } from "react-redux";
import { listTargets } from "../../store/actions/performanceSlice";
import Cookie from "cookie-universal";
import { useNavigate } from "react-router-dom";
import { removeToken } from "../../store/actions/AuthSlice";
import { clearSession } from "../../session";
import AOS from 'aos';
import 'aos/dist/aos.css';
const cookie = Cookie();
function NewSection() {
  const [type, setType] = useState(0);
  const [openTarget, setOpenTarget] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [showAddTargetModal, setShowAddTargetModal] = useState(false);
  const [imageError, setImageError] = useState(false);
  // The login response (kept in a cookie) carries the balance as it was at
  // login; gifts and transfers change it since. Refreshed from the backend.
  const [liveCoins, setLiveCoins] = useState(null);
  
  const { data } = useSelector(state => state.auth);
 
  const dispatch = useDispatch();

  // Function to check if image URL is valid
  const isValidImageUrl = (url) => {
    if (!url || typeof url !== 'string') return false;
    
    // Check if it's a valid URL format
    try {
      new URL(url);
    } catch {
      return false;
    }
    
    // Check if it has image extension
    const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
    const urlLower = url.toLowerCase();
    return imageExtensions.some(ext => urlLower.includes(ext)) || urlLower.includes('image');
  };

  // Handle image load error
  const handleImageError = () => {
    setImageError(true);
  };

  // Reset image error when data changes
  useEffect(() => {
    setImageError(false);
  }, [data?.img]);

  // Handle page change
  const navigate = useNavigate()
  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  // Handle target added successfully
  const handleTargetAdded = () => {
    // Refresh the targets list
    if (data?.id) {
      dispatch(listTargets({ 
        id: data.id, 
        page: currentPage, 
        limit: itemsPerPage 
      }));
    }
    // Switch back to the first tab to show the updated list
    setType(0);
  };

  // Handle modal close
  const handleCloseAddTargetModal = () => {
    setShowAddTargetModal(false);
    setType(0); // Switch back to first tab
  };

  useEffect(() => {
    getCategoryAnalytics({ from: new Date().toISOString().slice(0, 10), to: new Date().toISOString().slice(0, 10) })
      .then((r) => r?.category && setLiveCoins(r.category.coins))
      .catch(() => {});
  }, [type]);

  // Initialize AOS
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
      mirror: false,
      offset: 100,
    });
  }, []);

  // Fetch targets with pagination
  useEffect(() => {
    if (data?.id) {
      dispatch(listTargets({ 
        id: data.id, 
        page: currentPage, 
        limit: itemsPerPage 
      }));
    }
  }, [dispatch, data?.id, currentPage, itemsPerPage]);

const handleLogout = () => {
    clearSession();
    cookie.remove('categoryData');
    dispatch(removeToken());
    navigate("/");

}
  return (
    <div className="d-flex min-vh-100 login-linear-gradient position-relative overflow-hidden ">
       <img
            className="position-absolute top-0 end-0 z-n1"
            src={require("../../Assets/Login/blurRed.png")}
            alt="blurRed"
          />
          <img
            className="position-absolute bottom-0 start-0 z-n1"
            src={require("../../Assets/Login/blurBlue.png")}
            alt="blurBlue"
          />
           <div className="p-5" style={{ width: "100%" }}>
        <div className="text-white d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center gap-3">
            {/* User Image or Placeholder */}
            {data?.img && isValidImageUrl(data.img) && !imageError ? (
              <img 
                src={data.img} 
                alt="User Avatar"
                style={{ 
                  width: "36.39px", 
                  height: "36.39px", 
                  borderRadius: "50%",
                  objectFit: "cover"
                }}
                onError={handleImageError}
                data-aos="fade-right" 
                data-aos-delay="50"
              />
            ) : (
              <div 
                className="null-img"
                data-aos="fade-right" 
                data-aos-delay="50"
              >
                {data?.username?.charAt(0)?.toUpperCase() || 'U'}
              </div>
            )}
            <h2 data-aos="fade-right" data-aos-delay="100"> {data?.username}</h2>
          </div>
          <div className="d-flex align-items-start justify-content-center gap-5">

            <div data-aos="fade-left" data-aos-delay="200">
              <div
                className="d-flex align-items-center justify-content-center gap-4 py-3 px-5 rounded"
                style={{
                  background:
                    " linear-gradient(95.7deg, #121327 49.37%, rgba(252, 21, 92, 0.8) 87.11%)",
                }}
              >
                <img src={img} style={{ width: "30px" }} alt="" />
                <h4 className="m-0 p-0">{num(liveCoins ?? data?.coins ?? 0)}</h4>
              </div>
            </div>
            <button
              className="btn btn-danger px-5 py-3"
              onClick={handleLogout}
              data-aos="fade-left" 
              data-aos-delay="300"
            >
              Logout
            </button>

          </div>
        </div>

        <div
          style={{ marginBottom: "6rem" }}
          className=" mt-5 text-white  gap-5 d-flex align-items-center justify-content-center"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <h3
            style={{ opacity: type === 0 ? 1 : 0.5, cursor: "pointer" }}
            onClick={() => {
              if (type !== 0) {
                setType(0);
                setCurrentPage(1); // Reset pagination when switching tabs
              } else {
                setOpenTarget(false);
              }
            }}
            data-aos="zoom-in"
            data-aos-delay="500"
          >
            Access Assigned Targets
          </h3>
          <h3
            style={{ opacity: type === 1 ? 1 : 0.5, cursor: "pointer" }}
            onClick={() => {
              setType(1);
              setCurrentPage(1); // Reset pagination when switching tabs
            }}
            data-aos="zoom-in"
            data-aos-delay="600"
          >
            Send Coins
          </h3>
          <h3
            style={{ opacity: type === 2 ? 1 : 0.5, cursor: "pointer" }}
            onClick={() => {
              setType(2);
              setShowAddTargetModal(true);
            }}
            data-aos="zoom-in"
            data-aos-delay="700"
          >
            Add Target
          </h3>
          <h3
            style={{ opacity: type === 3 ? 1 : 0.5, cursor: "pointer" }}
            onClick={() => setType(3)}
            data-aos="zoom-in"
            data-aos-delay="800"
          >
            Analytics
          </h3>
        </div>

        {/* Running / paused / stopped, time left this month, collected so far. */}
        <RunStatusBar refreshKey={type} />

        {type === 0 && (
          <div data-aos="fade-up" data-aos-delay="700">
            <Access 
              openTarget={openTarget} 
              setOpenTarget={setOpenTarget}
              onPageChange={handlePageChange}
              currentPage={currentPage}
            />
          </div>
        )}
        {type === 1 && (
          <div data-aos="fade-up" data-aos-delay="700">
            <SendCoins />
          </div>
        )}

        {type === 3 && (
          <div data-aos="fade-up" data-aos-delay="200">
            <Analytics onBalance={setLiveCoins} />
          </div>
        )}

        {/* Add Target Modal */}
        <AddTarget
          show={showAddTargetModal}
          onHide={handleCloseAddTargetModal}
          categoryId={data?.id}
          onTargetAdded={handleTargetAdded}
        />
      </div>
    </div>
  );
}

export default NewSection;
